const restrictedFields = ['name'];

export default restrictedFields;
